import { calculateCouponTotalAmount } from "types/coupon"
import { TimePeriods } from "types/membership"
import { PaymentMethod } from "types/payment"

export function getTotal({
    price,
    discount = 0,
    initial_fee = 0,
}: {
    price: number
    discount?: number
    initial_fee?: number
}) {
    return price + initial_fee - discount
}

export function calculateCouponPercentageValue(value: number, price: number) {
    return (value * price) / 100
}

export function getTotalOnCouponBasis(couponInfo: any, price: number, recurring_count: number = 1) {
    const value = couponInfo?.discountValue as number
    let res
    switch (couponInfo?.discountType as string) {
        case 'PERCENT':
            res = calculateCouponTotalAmount(price, couponInfo, recurring_count)
            break
        case 'EXACT_VALUE':
            res = recurring_count * value
            break
        default:
            res = 0
            break
    }
    return res
}

export function getGrandTotal({
    couponInfo,
    discount = 0,
    initial_fee = 0,
    paymentMethod,
    price,
}: {
    couponInfo: any
    discount?: number
    paymentMethod: string
    price: number
    initial_fee?: number
}) {
    if (paymentMethod == PaymentMethod.MEMBER) {
        return 0
    }

    const total = getTotal({
        price,
        initial_fee,
        discount,
    })

    return calculateCouponTotalAmount(
        total,
        couponInfo,
    )
}

export function getTimePeriodShort(time_period: string) {
    const period = TimePeriods.find(tp => tp.value == time_period)
    return period?.short || time_period
}
